import React from "react";

const Page404 = () => (
  <div className="not-found">
    <div className="not-found-content">
      <h1 className="not-found-title">404</h1>
      <p className="not-found-message">
        Oops! The page you're looking for doesn't exist.
      </p>
      <a className="not-found-link" href="/Dashboard">
        Go to Dashboard
      </a>
    </div>
  </div>
);

export default Page404;
